export { ResultLink } from './ResultLink';
